import React, { useState } from "react";
import "./editableSelect.css";
import EditIcon from "@mui/icons-material/Edit";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import PropTypes from "prop-types";

const EditableSelect = ({
  options = [],
  type = "text",
  title = "",
  editableText = false,
  placeholder = "",
  value = "",
  selected = "",
  onChangeValue = () => {},
  onEditClick = () => {},
}) => {
  const [editable, setEditable] = useState(false);

  return (
    <div className="inputDefaultWrapperES">
      <div>
        <h6>{title}</h6>
        {/* <p>{email}</p> */}
        {editable ? (
          <div className=" ">
            <div>
              <div className="select-data" style={{ width: "98%" }}>
                <select name="gender" onChange={onChangeValue}>
                  {options?.map((item, index) => {
                    if (item.toUpperCase().trim() === selected.toUpperCase().trim()) {
                      return (
                        <option key={index} value={item.toUpperCase()} selected>
                          {item}
                        </option>
                      );
                    } else {
                      return (
                        <option key={index} value={item.toUpperCase()}>
                          {item}
                        </option>
                      );
                    }
                  })}
                </select>
              </div>
            </div>
          </div>
        ) : (
          <input
            type={type}
            className="inputDefaultES"
            placeholder={placeholder}
            disabled={!editable}
            onChange={onChangeValue}
            value={value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()}
          />
        )}

        {editableText && (
          <div
            className="editIconInput"
            onClick={() => {
              editable ? setEditable(false) : setEditable(true);
              onEditClick(!editable);
            }}
          >
            {!editable ? (
              <EditIcon className="editIconSize" />
            ) : (
              <DoneOutlineIcon className="editIconSize" />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

EditableSelect.propTypes = {
  options: PropTypes.array,
  type: PropTypes.string,
  title: PropTypes.string,
  placeholder: PropTypes.string,
  editableText: PropTypes.bool,
  onChangeValue: PropTypes.func,
  value: PropTypes.any,
  onEditClick: PropTypes.func,
};

EditableSelect.defaultProps = {
  title: "Title",
  placeholder: "PlaceHolder",
  editableText: true,
};
export default EditableSelect;
